import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  AppBar,
  Toolbar,
  Typography,
  Box,
  CssBaseline,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useApp } from "../context/AppContext";
import { getOrganization } from "../apis/apiList/organizationApi";
import { useMessage } from "../context/MessageContext";

const collapsedWidth = 60;
const expandedWidth = 265;

const MainLayout = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { userDetails, logout } = useApp();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [menuItems, setMenuItems] = useState([]);
  const { id } = useParams();
  const {showMessage} =useMessage()
  
  // console.log('id', id); 
  // console.log('userDetails main layout', userDetails)
  useEffect(()=>{

    async function fetchOrg() {
      try {
        // console.log('org', orgdata);
        let isEditor = false;
        let editorJobTitles = ["editor", "videographer/editor", "video editor", "animator/editor"];
        if(userDetails.role == 'admin' && userDetails.jobTitle && editorJobTitles.includes(userDetails.jobTitle.toLowerCase())){
          isEditor = true;
        }

        if(id){
          const orgdata = await getOrganization({id});
          // console.log('org.data', orgdata.data);
          const org = orgdata.data


          let menuItemsAdmin = [
            { text: org.organizationName, imgSrc: '/images/menu-icon/menu-home.png', link: `/org/${org._id}/projects` },
            { text: "Organizations", imgSrc: '/images/menu-icon/menu-organizations.png', link: `/organization/list` },
            { text: "Assets", imgSrc: '/images/menu-icon/menu-assets.png', link: `/org/${org._id}/assets` },
            { text: "Style Guide", imgSrc: '/images/menu-icon/sd-icon1.png', link: `/org/${org._id}/styleguide` },
            { text: "Avatars", imgSrc: '/images/menu-icon/avatarList.png', link: `/org/${org._id}/avatars` },
            { text: "Tasks", imgSrc: '/images/menu-icon/menu-tasks.png', link: `/task/list` },
            { text: "Templates", imgSrc: '/images/menu-icon/multimedia-new.png', link: `/manage/templates` },
            ...(userDetails.email == process.env.REACT_APP_JIM_EMAIL || userDetails.email == process.env.REACT_APP_DARCY_EMAIL
            ? [
                { text: "Manage Editor", imgSrc: '/images/menu-icon/editor-management.png', link: `/manage/editors` },
                { text: "Meetings", imgSrc: '/images/menu-icon/videocall.png', link: `/org/meetings` },
                // { text: "Buy Plan", imgSrc: '/images/menu-icon/subscription.png', link: `/org/${org._id}/subscribe/plan` },
             ]
            : []),
            ...(isEditor
            ? [
              { text: "Profile", imgSrc: '/images/menu-icon/menu-profile.png', link: `/editor/profile` }
            ]
            : []),
            // { text: "Newsletters", imgSrc: '/images/menu-icon/newsletter-20.png', link: `/newsletter/list` },
            // { text: "Manage Editor", imgSrc: '/images/menu-icon/editor-management.png', link: `/manage/editors` },
            { text: "Newsletters", imgSrc: '/images/menu-icon/newsletter-20.png', link: `/org/${org._id}/newsletter/list` },
            { text: "Invoices", imgSrc: '/images/menu-icon/invoice.png', link: `/org/${org._id}/invoices` },
            { text: "Logout", imgSrc: '/images/menu-icon/menu-logout.png', link: `/` },
          ];
          
          // console.log('menuItemsAdmin', menuItemsAdmin)
          setMenuItems(menuItemsAdmin)
        } else {
          let menuItemsAdmin = [
            { text: "Organizations", imgSrc: '/images/menu-icon/menu-organizations.png', link: `/organization/list` },
            // { text: "My Profile", imgSrc: '/images/menu-icon/menu-profile.png', link: `/profile` },
            { text: "Templates", imgSrc: '/images/menu-icon/multimedia-new.png', link: `/manage/templates` },
            ...(userDetails.email == process.env.REACT_APP_JIM_EMAIL || userDetails.email == process.env.REACT_APP_DARCY_EMAIL
            ? [
              { text: "Meetings", imgSrc: '/images/menu-icon/videocall.png', link: `/org/meetings` },
              { text: "Manage Editor", imgSrc: '/images/menu-icon/editor-management.png', link: `/manage/editors` },
              { text: "Subscribers", imgSrc: '/images/menu-icon/subscribe.png', link: `/subscription/list` },
              { text: "PARIS Conversations", imgSrc: '/images/menu-icon/chatbot.png', link: `/ask-paris/conversations` },
            ]
            : []),
            ...(isEditor
            ? [{ text: "Profile", imgSrc: '/images/menu-icon/menu-profile.png', link: `/editor/profile` }]
            : []),
            { text: "Newsletters", imgSrc: '/images/menu-icon/newsletter-20.png', link: `/newsletter/list` },
            { text: "Tasks", imgSrc: '/images/menu-icon/menu-tasks.png', link: `/task/list` },
            { text: "Logout", imgSrc: '/images/menu-icon/menu-logout.png', link: `/` },
          ];
          
          // console.log('menuItemsAdmin', menuItemsAdmin)
          setMenuItems(menuItemsAdmin)
        }
      } catch(error){
        showMessage( error?.response?.data?.message || "Something went wrong", "error" );
      }
    }

    if(userDetails){
      // console.log('in if userDetails', userDetails)
      if(userDetails.role == 'admin' || userDetails.role == 'production-assistant'){
        fetchOrg();

      } else if(userDetails.role == 'subscriber'){
        // console.log('userDetails.organization', userDetails.organization)
        let menuItemsUser = [
          { text: userDetails.organization, imgSrc: '/images/menu-icon/menu-home.png', link: `/subs/org/${userDetails.orgId}/projects` },
          { text: "Assets", imgSrc: '/images/menu-icon/menu-assets.png', link: `/subs/org/${userDetails.orgId}/assets` },
          { text: "Templates", imgSrc: '/images/menu-icon/multimedia-new.png', link: `/subs/org/${userDetails.orgId}/templates` },
          { text: "Avatars", imgSrc: '/images/menu-icon/avatarList.png', link: `/subs/org/${userDetails.orgId}/avatars` },
          { text: "Style Guide", imgSrc: '/images/menu-icon/sd-icon1.png', link: `/subs/org/${userDetails.orgId}/styleguide` },
          { text: "Newsletters", imgSrc: '/images/menu-icon/newsletter-20.png', link: `/subs/org/${userDetails.orgId}/newsletter/list` },
          // { text: "Meetings", imgSrc: '/images/menu-icon/videocall.png', link: `/subs/org/${userDetails.orgId}/meetings` },
          { text: "Invoices", imgSrc: '/images/menu-icon/invoice.png', link: `/subs/org/${userDetails.orgId}/invoices` },
          { text: "Buy Plan", imgSrc: '/images/menu-icon/subscription.png', link: `/subs/org/${userDetails.orgId}/subscribe/plan` },
          { text: "Logout", imgSrc: '/images/menu-icon/menu-logout.png', link: `/` },
        ];
        setMenuItems(menuItemsUser)
      }
    } else {
      // navigate('/')
    }

  }, [userDetails])

  const handleLogout = ()=>{
    logout();
    navigate('/')
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <AppBar
        position="fixed"
        sx={{
          width: isMobile ? "100%" : `calc(100% - ${open ? expandedWidth : collapsedWidth}px)`,
          ml: isMobile ? 0 : `${open ? expandedWidth : collapsedWidth}px`,
          background: "#fff",
          color: "#000",
          transition: "all 0.3s ease-in-out",
          boxShadow: "none",
          borderBottom: "1px solid #ddd",
          alignItems: 'start',
        }}
      >
          {!open && isMobile && (
            <IconButton onClick={() => setOpen(true)} sx={{ mr: 2, ml:1, mt: 0.5 }}>
              <MenuIcon />
            </IconButton>
          )}
      </AppBar>

      {/* Sidebar Drawer */}
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          width: open ? expandedWidth : collapsedWidth,
          flexShrink: 0,
          transition: "transform 0.3s ease-in-out, width 0.3s ease-in-out",
          "& .MuiDrawer-paper": {
            width: open ? expandedWidth : collapsedWidth,
            boxSizing: "border-box",
            backgroundColor: "#161b25",
            color: "#fff",
            overflowX: "hidden",
            transition: "transform 0.3s ease-in-out, width 0.3s ease-in-out",
            transform: isMobile && !open ? "translateX(-100%)" : "translateX(0)",
          },
        }}
      >
        {/* Logo & Toggle Button */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pt: 2, pl:2, pr:1, mb: {xs: 3, md: 5} }}>
          {
            open && <img src="/images/sidebar-logo.png" style={{ display: "block", width: 'auto', height: '30px', marginLeft: '10px'}}/>
          }
          <IconButton onClick={() => setOpen(!open)} sx={{ color: "white", pt: 1, pl:0, pr:0 }}>
            {open ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>
        </Box>

        {/* Drawer Items */}
        <List>
          {menuItems && menuItems.length > 0 && menuItems.map((item, index) => (
            <ListItem
              button
              key={index}
              sx={{
                display: "flex",
                justifyContent: open ? "flex-start" : "center",
                padding: "12px 20px",
                paddingTop: 0.5,
                cursor: 'pointer',
                pl: 0,
                "&:hover": { backgroundColor: "#1e293b" },
              }}
              onClick={()=>{
                if (item.text.toLowerCase() === "logout") {
                  handleLogout();
                } else {
                  navigate(item.link)
                }
              }}
            >
              
              <ListItemIcon sx={{ color: "white", justifyContent: 'center', width: '20px', height: '20px', pl:1 }}>
                <img src={`${item.imgSrc}`} style={{maxWidth: '20px', maxHeight: '20px'}} />
              </ListItemIcon>
              {/* <Box sx={{ color: "white", justifyContent: 'center', width: '20px', height: '20px', pl:1 }}>
                <img src={`${item.imgSrc}`} style={{width: '20px', height: '20px'}} />
              </Box> */}
              {
                open &&
                <Typography variant={'h5'} sx={{ display: "block", color: "white", fontSize: '13px' }}>{item.text}</Typography>
              }
              {/* <ListItemText
                primary={item.text}
                sx={{ display: open ? "block" : "none", color: "white" }}
              /> */}
            </ListItem>
          ))}
        </List>
      </Drawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: isMobile ? "100%" : `calc(100% - ${open ? expandedWidth : collapsedWidth}px)`,
          transition: "width 0.3s ease-in-out",
          pt: 2,
          pl: isMobile? 1 : 4,
          pr: isMobile? 1 : 4,
          mt: isMobile? '35px': '0px'
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
